import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import biLogger from '@wix/web-bi-logger';
import s from './Subscription.scss';
import X from './x';
const bi = biLogger
  .factory({endpoint: 'updates'})
  .setDefaults({src: 19})
  .logger();
export interface SubscriptionCmpProps extends WithTranslation {
  'data-hooks'?: string;
  enabled: boolean;
  subscribed: boolean;
  autoCloseTimeout?: number;
  subscribe: () => void;
}

export interface SubscriptionCmpState {
  closed: boolean;
  visible: boolean;
  isThankYou: boolean;
}

export function subscribe() {
  return bi
    .log({evid: 345})
    .catch(() => Promise.resolve());
}

class SubscriptionCmp extends React.PureComponent<SubscriptionCmpProps, SubscriptionCmpState> {
  closeTimeout: any;

  constructor(props: SubscriptionCmpProps) {
    super(props);
    this.handleSubscriptionClick = this.handleSubscriptionClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = {
      isThankYou: false,
      closed: false,
      visible: false,
    };
  }
  handleSubscriptionClick() {
    return subscribe()
      .then(() => this.props.subscribe())
      .then(() => {
        this.setState({
          isThankYou: true
        });

        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout);
        }

        this.closeTimeout = setTimeout(() => this.setState({closed: true}), this.props.autoCloseTimeout || 2000);
      });
  }
  handleScroll() {
    this.setState({
      visible: window.scrollY > 800,
    });
  }
  handleCloseClick() {
    bi.log({
      evid: 346,
      click_source: this.props.subscribed ? 'done' : 'close'
    });
    this.setState({
      closed: true
    });
  }
  componentDidMount() {
    const {enabled, subscribed} = this.props;
    const required = enabled && !subscribed;
    window.addEventListener('scroll', this.handleScroll);
    this.setState({
      closed: subscribed,
    });

    bi.log({
      evid: 344,
      required: required ? 1 : 0,
      ...(!required && {reason: enabled ? 'subscribed' : 'not logged in'})
    });
  }
  componentWillUnmount() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }

    window.removeEventListener('scroll', this.handleScroll);
  }
  render() {
    const {t, 'data-hooks': dataHooks, enabled, subscribed} = this.props;
    const {isThankYou, visible, closed} = this.state;
    const hide = !enabled || !visible || closed || (subscribed && !isThankYou);
    return (
      <div data-hooks="subscription-dialog" className={s.subscriptionWrap}>
        <input
          data-hooks="hideCheckbox"
          type="checkbox"
          id={s.hideCheckbox}
          className={s.hideCheckbox}
          checked={hide}
          onChange={this.handleCloseClick}
        />
        <aside className={s.subscription} data-hooks={dataHooks}>
          {isThankYou ? (
            <div data-hooks="thankyou" className={s.thankyou}>
              {t('subscription.thankyou')}
            </div>
          ) : (
            <div className={s.subscibeBlock}>
              <p data-hooks="title" className={s.title}>
                {t('subscription.title')}
              </p>
              <p data-hooks="description" className={s.description}>
                {t('subscription.description')}
              </p>
              <div className={s.subscribeWrap}>
                <button
                  data-hooks="subscribe"
                  className={s.subscribe}
                  onClick={this.handleSubscriptionClick}
                >
                  {t('subscription.subscribe')}
                </button>
              </div>
            </div>
          )}
          <label htmlFor={s.hideCheckbox} data-hooks="close" className={s.close}>
            <X />
          </label>
        </aside>
      </div>
    );
  }
}
export const Subscription = withTranslation()(SubscriptionCmp);
